// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2QZO0","fileBtn":"File_fileBtn__291jH","closeBtn":"File_closeBtn__2ePaJ","fileSelected":"File_fileSelected__2522j","disabled":"File_disabled__1_0e8"};